<template>
  <App :session="session" :office_id="office_id">
    <div class="aff-tabs">
      <span class="aff-tabs__link is-active">Afiliación</span>
    </div>

    <i class="load" v-if="loading"></i>

    <div class="aff" v-if="!loading">
      <!-- Felicitaciones -->
      <div v-if="congrats" class="aff-congrats">
        <img
          class="aff-congrats__img"
          src="https://ik.imagekit.io/asu/vitalyfuxion/trofeo%20vitalf_iSHGhkIYI.png"
          alt="Felicitaciones"
        />
      </div>

      <!-- Pendiente -->
      <div v-else-if="pending" class="aff-pending">
        <div class="aff-pending__card">
          <i class="fas fa-hourglass-half"></i>
          <h3>¡Solicitud enviada!</h3>
          <p>Tu afiliación está pendiente de aprobación.</p>
          <div class="aff-pending__plan" v-if="affiliation && affiliation.plan">
            <strong>{{ affiliation.plan.name }}</strong>
            <span>Bs {{ affiliation.plan.amount }}</span>
          </div>
          <div class="aff-pending__list" v-if="affiliation && affiliation.products">
            <p v-for="(product, i) in affiliation.products" :key="i" v-if="product.total > 0">
              {{ product.total }} × {{ product.name }}
            </p>
          </div>
        </div>
      </div>

      <!-- Flujo principal -->
      <template v-else>
        <!-- PASO 1: Plan + productos -->
        <template v-if="step === 1">
          <section class="aff-main">
            <header class="aff-header aff-header--desktop">
              <div>
                <h2 class="aff-title">Elige tu plan de afiliación</h2>
                <p class="aff-subtitle">
                  Selecciona el plan, escoge tus productos y confirma tu solicitud.
                </p>
              </div>
            </header>

            <!-- Planes -->
            <div class="aff-plans" v-if="plans && plans.length">
              <button
                type="button"
                class="aff-plan"
                v-for="plan in plans"
                :key="plan.id || plan.name"
                :class="{ 'is-active': selec_plan && (selec_plan.id === plan.id || selec_plan.name === plan.name) }"
                @click="selec_plan = plan"
              >
                <div class="aff-plan__img">
                  <img v-if="plan.img" :src="plan.img" :alt="plan.name" />
                  <span v-else>PLAN</span>
                </div>
                <strong>{{ plan.name }}</strong>
                <div class="aff-plan__price">Bs {{ plan.amount }}</div>
                <small v-if="plan.max_mode === 'max_products'">
                  Escoges {{ plan.max_products }} productos
          </small>
                <small v-else-if="plan.max_mode === 'exact_weight_points'">
                  {{ plan.exact_weight_points }} pts en productos
          </small>
                <small v-else-if="plan.max_mode === 'slots_categories'">
                  Por categorías
                </small>
              </button>
        </div>

            <p class="aff-hint" v-if="selec_plan">
              <template v-if="max_mode == 'max_products'">
                Escoger {{ text_value_max_mode }} producto(s) · seleccionados {{ total }} / {{ text_value_max_mode }}
              </template>
              <template v-else-if="max_mode == 'slots_categories'">
            Escoger:
                <span v-for="(slots_categorie, i) in slots_categories" :key="i">
                  {{ slots_categorie.to_select }} {{ slots_categorie.type }}
                  <template v-if="i < slots_categories.length - 1"> / </template>
            </span>
                · total {{ total }}
              </template>
              <template v-else-if="max_mode == 'exact_weight_points'">
                Escoger {{ text_value_max_mode }} puntos en productos · actual {{ total }}
              </template>
            </p>

            <div class="aff-toolbar">
              <label class="aff-search">
                <i class="fas fa-search"></i>
                <input v-model.trim="search" type="search" placeholder="Búsqueda..." />
              </label>
              <div class="aff-filters">
                <button
                  type="button"
                  class="aff-chip"
                  :class="{ 'is-active': category === 'Todos' }"
                  @click="category = 'Todos'"
                >
                  Todos
                </button>
                <button
                  type="button"
                  class="aff-chip"
                  v-for="cat in categories"
                  :key="cat"
                  :class="{ 'is-active': category === cat }"
                  @click="category = cat"
                >
                  {{ cat }}
                </button>
              </div>
          </div>

            <!-- Barra carrito móvil sticky (como Sifrah) -->
            <div
              v-if="selec_plan"
              class="cart-button-mobile-anchor aff-mobile-cart-anchor"
              :style="mobileCartStuck ? { minHeight: mobileCartBarHeight + 'px' } : null"
            >
              <div ref="mobileCartSentinel" class="cart-button-mobile-sentinel aff-mobile-cart-sentinel" aria-hidden="true"></div>
              <div
                class="cart-button-container-mobile aff-mobile-cart"
                :class="{ 'is-hidden': showCartModal, 'is-stuck': mobileCartStuck }"
                :style="mobileCartStuckStyle"
              >
                <div class="cart-info-left aff-mobile-cart__info">
                  <div class="cart-price-info">
                    <span class="total-price">Monto: Bs {{ Number(selec_plan.amount || 0).toFixed(2) }}</span>
                    <span class="total-items">Puntos: {{ selec_plan.affiliation_points || 0 }} pts</span>
                  </div>
                </div>
                <button type="button" class="cart-square-btn aff-mobile-cart__btn" @click="showCartModal = true">
                  <i class="fas fa-shopping-cart"></i>
                  <span>Ver carrito</span>
                </button>
              </div>
            </div>

            <div class="products-count-indicator aff-count">
              <span>Mostrando {{ filteredProducts.length }} de {{ products.length }} productos</span>
              <span v-if="search || (category && category !== 'Todos')" class="filter-active">
                (filtros activos)
              </span>
            </div>

            <div class="products-catalog-grid aff-grid">
              <article
                class="product-catalog-card aff-card"
                v-for="product in filteredProducts"
                :key="product.id || product.name"
              >
                <div class="card-corner"></div>
                <div class="points-badge aff-card__badge" v-if="product.points || product.weight_points">
                  <i class="fas fa-star"></i>
                  {{ product.points || product.weight_points }} pts
                </div>
                <div class="product-image-container aff-card__img">
                  <img v-if="product.img" :src="product.img" :alt="product.name" class="product-catalog-img" />
                </div>
                <div class="product-catalog-info aff-card__info">
                  <h3 class="product-catalog-name aff-card__name">{{ product.name }}</h3>
                  <div class="product-catalog-info-text aff-card__type">{{ product.type || '\u00a0' }}</div>
                  <div class="product-catalog-price">
                    Precio Socio: <span class="price-amount aff-card__price">Bs {{ product.price }}</span>
                  </div>
                </div>
                <div class="product-quantity-controls aff-card__controls" v-if="product.edit && product.total > 0">
                  <button type="button" class="qty-control-btn btn-ctrl" @click.stop="less(product)">−</button>
                  <span class="quantity-display ctrl-qty">{{ product.total }}</span>
                  <button type="button" class="qty-control-btn btn-ctrl" @click.stop="more(product)">+</button>
                </div>
                <div class="add-to-cart-container" v-else-if="product.edit">
                  <button
                    type="button"
                    class="add-to-cart-btn aff-card__btn"
                    @click.stop="more(product)"
                  >
                    <i class="fas fa-shopping-cart"></i>
                    Agregar
                  </button>
                </div>
                <div class="add-to-cart-container" v-else>
                  <button type="button" class="add-to-cart-btn aff-card__btn is-disabled" disabled>
                    No disponible
                  </button>
              </div>
            </article>
          </div>

            <p class="aff-error" v-if="error">{{ error }}</p>
            <p class="aff-error" v-if="error_price">Agregue más productos</p>
          </section>

          <!-- Sidebar desktop -->
          <aside class="aff-cart">
            <div class="aff-cart__head">
              <h3>
                <i class="fas fa-shopping-cart"></i>
                Carrito de afiliación
              </h3>
              <p v-if="selec_plan">
                Plan {{ selec_plan.name }}
                <template v-if="max_mode === 'max_products'">
                  · {{ total }} / {{ selec_plan.max_products }} productos
                </template>
              </p>
            </div>

            <div class="aff-cart__body" v-if="cartItems.length">
              <article class="aff-cart-item" v-for="item in cartItems" :key="item.id || item.name">
                <img v-if="item.img" :src="item.img" :alt="item.name" />
                <div class="aff-cart-item__info">
                  <strong>{{ item.name }}</strong>
                  <small v-if="max_mode === 'exact_weight_points'">
                    {{ item.total_weight_points || 0 }} pts
          </small>
                </div>
                <div class="aff-cart-item__actions" v-if="item.edit">
                  <div class="aff-cart-item__qty">
                    <button type="button" @click="less(item)">−</button>
                    <span>{{ item.total }}</span>
                    <button type="button" @click="more(item)">+</button>
                  </div>
                </div>
              </article>
            </div>
            <div class="aff-cart__empty" v-else>
              <i class="fas fa-shopping-cart"></i>
              <p>Tu carrito está vacío</p>
              <small>Agrega productos para comenzar</small>
            </div>

            <div class="aff-cart__summary" v-if="selec_plan">
              <div class="row"><span>Total productos</span><span>{{ total }}</span></div>
              <div class="row" v-if="max_mode === 'exact_weight_points'">
                <span>Peso puntos</span><span>{{ total }}</span>
              </div>
              <div class="row">
                <span>Puntos plan</span>
                <span>{{ selec_plan.affiliation_points || 0 }}</span>
              </div>
              <div class="row row--total">
                <span>Total afiliación</span>
                <span>Bs {{ selec_plan.amount }}</span>
              </div>
            </div>

            <div class="aff-cart__actions">
              <button type="button" class="btn btn--primary" @click="goCheckout">
                Continuar al pago
              </button>
              <button type="button" class="btn btn--ghost" @click="showCartModal = true">
                Ver detalle
              </button>
            </div>
          </aside>

          <!-- Modal carrito -->
          <div class="aff-overlay" :class="{ 'is-open': showCartModal }" @click.self="showCartModal = false">
            <aside class="aff-cart aff-cart--modal">
              <div class="aff-cart__head">
                <h3>
                  <i class="fas fa-shopping-cart"></i>
                  Carrito de afiliación
                </h3>
                <button type="button" class="aff-cart__close" @click="showCartModal = false">
                  <i class="fas fa-times"></i>
                </button>
                <p v-if="selec_plan">Plan {{ selec_plan.name }}</p>
              </div>
              <div class="aff-cart__body" v-if="cartItems.length">
                <article class="aff-cart-item" v-for="item in cartItems" :key="'m-' + (item.id || item.name)">
                  <img v-if="item.img" :src="item.img" :alt="item.name" />
                  <div class="aff-cart-item__info">
                    <strong>{{ item.name }}</strong>
                  </div>
                  <div class="aff-cart-item__actions" v-if="item.edit">
                    <div class="aff-cart-item__qty">
                      <button type="button" @click="less(item)">−</button>
                      <span>{{ item.total }}</span>
                      <button type="button" @click="more(item)">+</button>
                    </div>
                  </div>
                </article>
              </div>
              <div class="aff-cart__empty" v-else>
                <p>Tu carrito está vacío</p>
              </div>
              <div class="aff-cart__summary" v-if="selec_plan">
                <div class="row row--total">
                  <span>Total afiliación</span>
                  <span>Bs {{ selec_plan.amount }}</span>
                </div>
              </div>
              <div class="aff-cart__actions">
                <button type="button" class="btn btn--ghost" @click="showCartModal = false">
                  Seguir eligiendo
                </button>
                <button type="button" class="btn btn--primary" @click="goCheckout">
                  Continuar al pago
                </button>
              </div>
            </aside>
          </div>
        </template>

        <!-- PASO 2: Pago (misma lógica de siempre) -->
        <template v-else>
          <section class="aff-main">
            <header class="aff-header">
              <div>
                <h2 class="aff-title">Confirma tu afiliación</h2>
                <p class="aff-subtitle">
                  Selecciona la oficina, revisa los datos de pago y elige cómo deseas pagar.
                </p>
            </div>
            </header>

            <div class="aff-checkout-block">
              <h3 class="aff-checkout-block__title"><span>1</span> Selecciona la oficina</h3>
              <label class="aff-field">
                <span>Oficina de atención</span>
                <select v-model="office" :disabled="!!office_id">
                  <option :value="null" disabled>Selecciona una oficina</option>
                  <option v-for="o in offices" :key="o.id || o.name" :value="o">{{ o.name }}</option>
                </select>
              </label>
              <p class="aff-field-hint" v-if="office">{{ office.address }}</p>
            </div>

            <div class="aff-payinfo" v-if="office">
              <div class="aff-pay-card">
                <h4>Datos para realizar el pago</h4>
                <pre>{{ office.accounts }}</pre>
              </div>
              <div class="aff-pay-card">
                <h4>QR de pago</h4>
                <img
                  :src="office.qr_image || office.qr || defaultQr"
                  alt="QR de pago"
              />
            </div>
          </div>

            <div class="aff-checkout-block">
              <h3 class="aff-checkout-block__title"><span>2</span> Aplica tu saldo</h3>
              <label class="aff-toggle">
                <span>Deseo usar mi saldo disponible</span>
            <input type="checkbox" v-model="check" />
          </label>
              <div class="aff-balance" v-if="check && platform_configs">
                <p v-if="platform_configs.show_ballance.aff">
                  Saldo bono afiliados: <b>Bs {{ _balance_aff }}</b>
                </p>
                <p>Saldo no disponible: <b>Bs {{ _balance }}</b></p>
                <p v-if="platform_configs.show_ballance.main">
                  Saldo disponible: <b>Bs {{ balance }}</b>
                </p>
                <p>Restan: <b>Bs {{ remaining }}</b></p>
              </div>
            </div>

            <div class="aff-checkout-block">
              <h3 class="aff-checkout-block__title"><span>3</span> Medio de pago</h3>
              <div class="aff-pay-methods">
                <button
                  type="button"
                  class="aff-pay-method"
                  :class="{ 'is-selected': pay_method === 'bank' }"
                  @click="pay_method = 'bank'"
                >
                  <i class="fas fa-university"></i>
            <div>
                    <strong>Transferencia</strong>
                    <small>Realiza una transferencia desde tu banco.</small>
            </div>
                </button>
                <button
                  type="button"
                  class="aff-pay-method"
                  :class="{ 'is-selected': pay_method === 'cash' }"
                  @click="pay_method = 'cash'"
                >
                  <i class="fas fa-money-bill-wave"></i>
                  <div>
                    <strong>Efectivo</strong>
                    <small>Paga en oficina con dinero en efectivo.</small>
                  </div>
                </button>
          </div>

              <div class="aff-transfer" v-if="pay_method === 'bank'">
                <p class="aff-transfer__monto">Monto: Bs {{ remaining }}</p>
                <div class="aff-transfer__grid">
                  <label class="aff-field">
                    <span>Entidad financiera</span>
                    <input v-model="bank" placeholder="Entidad" />
          </label>
                  <label class="aff-field">
                    <span>Fecha de pago</span>
                    <input v-model="date" type="date" />
          </label>
                  <label class="aff-field">
                    <span>Número de voucher</span>
            <input
              v-model="voucher_number"
                      placeholder="Número de operación"
                      @input="voucher_number = ($event.target.value || '').replace(/[^0-9]/g, '')"
                    />
                  </label>
                </div>
                <label class="aff-upload" :class="{ 'has-file': !!voucher }">
                  <input type="file" accept="image/*,.pdf" @change="change" />
                  <img v-if="voucher" :src="voucher" alt="Comprobante" />
                  <template v-else>
                    <i class="fas fa-cloud-upload-alt"></i>
                    <strong>Adjuntar comprobante de pago</strong>
                  </template>
            </label>
          </div>

              <div class="aff-cash" v-if="pay_method === 'cash'">
                <p>Monto a pagar en oficina: <b>Bs {{ remaining }}</b></p>
              </div>
          </div>

            <p class="aff-error" v-if="error">{{ error }}</p>
            <p class="aff-error" v-if="error_price">Agregue más productos</p>

            <div class="checkout-mobile-actions">
              <div class="checkout-mobile-actions__summary" v-if="selec_plan">
                <div class="row"><span>Total</span><span>Bs {{ selec_plan.amount }}</span></div>
                <div class="row" v-if="selec_plan.affiliation_points">
                  <span>Puntos</span>
                  <span>{{ selec_plan.affiliation_points }} pts</span>
                </div>
              </div>
              <button type="button" class="btn btn--ghost" @click="step = 1" :disabled="sending">
                <i class="fas fa-arrow-left"></i>
                Volver
              </button>
              <button type="button" class="btn btn--primary" v-show="!sending" @click="POST">
                Enviar Afiliación
              </button>
              <button type="button" class="btn btn--primary" v-show="sending" disabled>
                Enviando Voucher ...
              </button>
            </div>
          </section>

          <aside class="aff-cart aff-cart--checkout">
            <div class="aff-cart__head">
              <h3>Resumen</h3>
              <p v-if="selec_plan">Plan {{ selec_plan.name }}</p>
            </div>
            <div class="aff-cart__body" v-if="cartItems.length">
              <article class="aff-cart-item" v-for="item in cartItems" :key="'c-' + (item.id || item.name)">
                <img v-if="item.img" :src="item.img" :alt="item.name" />
                <div class="aff-cart-item__info">
                  <strong>{{ item.name }}</strong>
                  <small>× {{ item.total }}</small>
                </div>
              </article>
            </div>
            <div class="aff-cart__summary" v-if="selec_plan">
              <div class="row row--total">
                <span>Total</span>
                <span>Bs {{ selec_plan.amount }}</span>
              </div>
            </div>
            <div class="aff-cart__actions">
              <button type="button" class="btn btn--ghost" @click="step = 1" :disabled="sending">
                Volver
              </button>
              <button type="button" class="btn btn--primary" v-show="!sending" @click="POST">
            Enviar Afiliación
          </button>
              <button type="button" class="btn btn--primary" v-show="sending" disabled>
            Enviando Voucher ...
          </button>
        </div>
          </aside>
        </template>
      </template>

      <div class="aff-invoices" v-if="affiliations && affiliations.length">
      <a
          v-for="(affItem, i) in affiliations"
        :key="i"
          :href="`${INVOICE_ROOT}?id=${affItem.id}`"
        target="_blank"
      >
          Boleta {{ i + 1 }}
      </a>
      </div>
    </div>
  </App>
</template>

<script>
import App from '@/views/layouts/App'
import api from '@/api'
import lib from '@/lib'

const INVOICE_ROOT = process.env.VUE_APP_INVOICE_ROOT
console.log({ INVOICE_ROOT })

export default {
  components: {
    App,
  },
  data() {
    return {
      // TODO: Configurable
      config: {
        slotStatic: false,
      },
      // END: Configurable
      platform_configs: null,
      loading: true,
      sending: false,

      plans: null,
      selec_plan: null,
      voucher: null,
      voucher_file: null,
      office: null,
      offices: null,

      pay_method: null,

      pending: false,
      congrats: false,

      check: false,
      INVOICE_ROOT,

      tab: null,
      products: null,
      product: null,

      error_price: false,

      error: null,

      bank: null,
      date: null,
      voucher_number: null,

      max_mode: null,
      text_value_max_mode: null,
      slots_categories: null,

      // solo UI
      step: 1,
      search: '',
      category: 'Todos',
      showCartModal: false,
      defaultQr: 'https://ik.imagekit.io/asu/vitalyfuxion/new_qr_FBSQSPj1i.jpg',
      balance: null,
      _balance: null,
      _balance_aff: null,
      affiliation: null,
      affiliations: null,
      mobileCartStuck: false,
      mobileCartBarHeight: 0,
      mobileCartStuckStyle: null,
      _mobileCartObserver: null,
    }
  },
  computed: {
    /**
     * @return {String}
     */
    session() {
      return this.$store.state.session
    },
    /**
     * @return {String}
     */
    office_id() {
      return this.$store.state.office_id
    },
    plan() {
      return this.$store.state.plan
    },
    categories() {
      if (!this.products) return []
      return this.products
        .map((x) => x.type)
        .filter((v, i, self) => i == self.indexOf(v))
    },
    filteredProducts() {
      if (!this.products) return []
      const q = (this.search || '').toLowerCase()
      return this.products.filter((p) => {
        const matchCat = this.category === 'Todos' || p.type === this.category
        const matchSearch = !q || (p.name || '').toLowerCase().includes(q)
        return matchCat && matchSearch
      })
    },
    cartItems() {
      if (!this.products) return []
      return this.products.filter((p) => p.total > 0)
    },
    /**
     * @return {Number}
     */
    total() {
      if (!this.products) return 0
      console.log('this.max_mode', this.max_mode)
      console.log(
        'this.products.reduce((a, b) => a + b.total_weight_points, 0)',
        this.products.reduce((a, b) => a + (b.total_weight_points || 0), 0)
      )
      switch (this.max_mode) {
        case 'exact_weight_points': {
          console.log(this.products.map((el) => el.total_weight_points))
          return this.products.reduce((a, b) => a + b.total_weight_points, 0)
        }
        default: {
          return this.products.reduce((a, b) => a + b.total, 0)
        }
      }
    },
    /**
     * @return {Number}
     */
    remaining() {
      if (!this.selec_plan) return 0
      if (this.check) {
        let ret =
          this.selec_plan.amount -
          (this.balance + this._balance + this._balance_aff)
        return ret > 0 ? ret : 0
      } else {
        return this.selec_plan.amount || this.price
      }
    },

    _amount() {
      if (!this.selec_plan) return ''
      return `Bs ${this.selec_plan.amount}  /  ${this.selec_plan.affiliation_points} pts`
    },
  },
  watch: {
    selec_plan() {
      if (!this.selec_plan) return
      this.slots_categories = this.selec_plan.slots_categories
      this.max_mode = this.selec_plan.max_mode
      this.text_value_max_mode = this.selec_plan[this.max_mode]
      this.totals()
      this.$nextTick(() => this.setupStickyMobileCart())
    },
    step() {
      this.$nextTick(() => this.setupStickyMobileCart())
    },
    loading(v) {
      if (!v) this.$nextTick(() => this.setupStickyMobileCart())
    },
  },
  mounted() {
    document.body.classList.add('vf-sticky-cart')
    this.$nextTick(() => this.setupStickyMobileCart())
    window.addEventListener('resize', this.setupStickyMobileCart)
  },
  beforeDestroy() {
    document.body.classList.remove('vf-sticky-cart')
    window.removeEventListener('resize', this.setupStickyMobileCart)
    if (this._mobileCartObserver) {
      this._mobileCartObserver.disconnect()
      this._mobileCartObserver = null
    }
  },
  async created() {
    // GET data
    const { data } = await api.Afiliation.GET(this.session)
    console.log({ data })

    this.loading = false

    // error
    if (data.error && data.msg == 'invalid session') this.$router.push('/login')

    // success
    this.$store.commit('SET_NAME', data.name)
    this.$store.commit('SET_LAST_NAME', data.lastName)
    this.$store.commit('SET_AFFILIATED', data.affiliated)
    this.$store.commit('SET_ACTIVATED', data.activated)
    this.$store.commit('SET__ACTIVATED', data._activated)
    this.$store.commit('SET_PLAN', data.plan)
    this.$store.commit('SET_COUNTRY', data.country)
    this.$store.commit('SET_PHOTO', data.photo)
    this.$store.commit('SET_TREE', data.tree)

    this.platform_configs = data.platform_configs
    data.plans.forEach((plan) => {
      plan.slots_categories.forEach((c) => {
        c['selected'] = 0
      })
    })

    this.plans = data.plans

    if (this.plans.length == 3) {
      this.selec_plan = this.plans[1]
    } else {
      this.selec_plan = this.plans[0]
    }

    this.products = this.toFullProduct(data.products)
    this.product = this.products[0]
    this.tab = this.categories[0]

    this.balance = data.balance
    this._balance = data._balance
    this._balance_aff = data._balance_aff

    this.offices = data.offices

    if (this.office_id && this.offices) {
      const foundOffice = this.offices.find((o) => o.id === this.office_id)
      if (foundOffice) this.office = foundOffice
    }

    this.affiliation = data.affiliation

    if (
      this.affiliation &&
      this.affiliation.plan.id == 'gold' &&
      this.affiliation.status == 'approved'
    )
      this.congrats = true

    if (this.affiliation && this.affiliation.status == 'pending')
      this.pending = true

    this.affiliations = data.affiliations

    if (!this.config.slotStatic) {
      // Completa los slots de la suma total de productos requeridos en la categoria
      this.max_mode = this.selec_plan.max_mode
      this.slots_categories = this.selec_plan.slots_categories
      switch (this.max_mode) {
        case 'slots_categories': {
          this.slots_categories.forEach((c) => {
            c['selected'] = 0
          })
          break
        }
        default: {
          this.text_value_max_mode = this.selec_plan[this.max_mode]
        }
      }
    }
  },

  methods: {
    setupStickyMobileCart() {
      if (typeof window === 'undefined') return
      this.removeStickyMobileCart()
      this.$nextTick(() => {
        if (window.innerWidth > 1099 || this.step !== 1 || !this.selec_plan) return

        const bar = this.$el.querySelector('.mobile-cart-bar')
          ? this.$el.querySelector('.mobile-cart-bar')
          : document.querySelector('.mobile-cart-bar')
        const anchor = document.querySelector('.mobile-cart-anchor')
        const sentinel = this.$refs.mobileCartSentinel || document.querySelector('.mobile-cart-sentinel')
        
        if (!bar || !sentinel || !anchor) {
          setTimeout(() => this.setupStickyMobileCart(), 120)
          return
        }

        const lockMetricsFromNaturalSize = () => {
          const source = this.mobileCartStuck ? anchor : bar;
          const rect = source.getBoundingClientRect();
          if (rect.width > 0) {
            this.mobileCartBarLeft = Math.round(rect.left);
            this.mobileCartBarWidth = Math.round(rect.width);
            this.mobileCartBarHeight = Math.round(rect.height || bar.offsetHeight || 72);
          }
        };

        lockMetricsFromNaturalSize();

        const applyStuck = (nextStuck) => {
          if (nextStuck && !this.mobileCartStuck) {
            lockMetricsFromNaturalSize();
          }
          if (!nextStuck) {
            this.mobileCartStuck = false;
            this.mobileCartStuckStyle = null;
            return;
          }
          this.mobileCartStuck = true;
          this.mobileCartStuckStyle = {
            width: `${this.mobileCartBarWidth}px`,
            left: `${this.mobileCartBarLeft}px`,
          };
        };

        const syncStuck = () => {
          if (this.showCartModal) {
            this.mobileCartStuck = false;
            this.mobileCartStuckStyle = null;
            return;
          }
          const top = sentinel.getBoundingClientRect().top;
          applyStuck(top <= 8);
        };

        if (typeof IntersectionObserver !== 'undefined') {
          this._mobileCartObserver = new IntersectionObserver(
            (entries) => {
              const entry = entries[0];
              if (!entry || this.showCartModal) {
                this.mobileCartStuck = false;
                this.mobileCartStuckStyle = null;
                return;
              }
              applyStuck(!entry.isIntersecting && entry.boundingClientRect.top < 8);
            },
            {
              root: null,
              threshold: 0,
              rootMargin: '-8px 0px 0px 0px',
            }
          );
          this._mobileCartObserver.observe(sentinel);
        }

        this._mobileCartOnScroll = syncStuck;
        this._mobileCartScrollTargets = [window];
        const content = document.querySelector('.app > section .content');
        if (content) this._mobileCartScrollTargets.push(content);
        const appEl = document.querySelector('.app');
        if (appEl) this._mobileCartScrollTargets.push(appEl);
        
        this._mobileCartScrollTargets.forEach((target) => {
          target.addEventListener('scroll', syncStuck, { passive: true });
        });
        
        this._mobileCartOnResize = () => {
          lockMetricsFromNaturalSize();
          syncStuck();
        };
        window.addEventListener('resize', this._mobileCartOnResize, { passive: true });
      })
    },
    removeStickyMobileCart() {
      if (this._mobileCartObserver) {
        this._mobileCartObserver.disconnect()
        this._mobileCartObserver = null
      }
      if (this._mobileCartScrollTargets && this._mobileCartOnScroll) {
        this._mobileCartScrollTargets.forEach(target => {
          target.removeEventListener('scroll', this._mobileCartOnScroll)
        })
        this._mobileCartScrollTargets = null
        this._mobileCartOnScroll = null
      }
      if (this._mobileCartOnResize) {
        window.removeEventListener('resize', this._mobileCartOnResize)
        this._mobileCartOnResize = null
      }
    },
    goCheckout() {
      this.error = null
      this.error_price = false
      this.showCartModal = false

      switch (this.max_mode) {
        case 'slots_categories': {
          const max_products_total = this.slots_categories.reduce(
            (a, c) => a + c.to_select,
            0
          )
          if (this.total < max_products_total) {
            this.error_price = true
            this.error = 'Seleccione los productos de las categorías necesarias'
            return
          }
          break
        }
        case 'max_products': {
          if (this.total < this.selec_plan.max_products) {
            this.error_price = true
            this.error = 'Seleccione más productos'
            return
          }
          break
        }
        case 'exact_weight_points': {
          if (this.total < this.selec_plan.exact_weight_points) {
            this.error_price = true
            this.error = `Seleccione más productos hasta cubrir los ${this.text_value_max_mode} pesos de puntos`
            return
          }
          break
        }
        default:
          break
      }

      this.step = 2
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    /**
     * Completa atributos adicionales al arreglo, para que el frontedn lo pueda utilizar
     * @param {Array} products
     * @return {Array}
     */
    toFullProduct(products) {
      products.forEach((product) => {
        product.total_weight_points = 0
      })
      return products.map((a) => ({ ...a, total: 0 }))
    },
    totals() {
      this.products.forEach((p) => {
        p.total = 0
        p.edit = true
        p.total_weight_points = 0
      })

      for (let p of this.selec_plan.products) {
        const i = this.products.findIndex((e) => e.id == p.id)
        if (i < 0) continue
        this.products[i].total = this.config.slotStatic ? p.total : 0
        this.products[i].edit = !this.config.slotStatic
      }
    },

    touch(i) {
      this.product = this.products[i]
      this.error_price = false
    },
    /**
     * @param {Object} product
     */
    more(product) {
      switch (this.max_mode) {
        case 'slots_categories': {
          const categorySelected =
            this.slots_categories.find((el) => el.type === product.type) || {}
          if (product.total >= categorySelected.to_select) return
          if (categorySelected.selected >= categorySelected.to_select) return

          // comparate max_products
          const max_products_total = this.slots_categories.reduce(
            (a, c) => a + c.to_select,
            0
          )
          if (this.total >= max_products_total) return
          product.total++
          categorySelected.selected++

          break
        }
        case 'max_products': {
          if (product.total >= this.selec_plan.max_products) return

          // comparate max_products
          if (this.total == this.selec_plan.max_products) return
          product.total++

          break
        }
        case 'exact_weight_points': {
          if (
            product.total_weight_points >= this.selec_plan.exact_weight_points
          ) {
            return
          }

          // comparate exact_weight_points
          if (this.total >= this.selec_plan.weight_points) return
          const preview_total = this.total + product.weight_points
          if (preview_total > this.selec_plan.exact_weight_points) return
          product.total++
          product.total_weight_points += product.weight_points
          break
        }
        default:
          break
      }
    },
    /**
     * @param {Object} product
     */
    less(product) {
      if (product.total <= 0) return
      product.total--
      console.log('product.weight_points', product.weight_points)
      switch (this.max_mode) {
        case 'slots_categories': {
          const categorySelected =
            this.slots_categories.find((el) => el.type === product.type) || {}
          categorySelected.selected--
          break
        }
        case 'exact_weight_points': {
          product.total_weight_points -= product.weight_points
          break
        }

        default:
          break
      }
    },

    change(e) {
      this.voucher_file = e.target.files[0]

      const reader = new FileReader()
      reader.onload = (e) => {
        this.voucher = e.target.result
      }

      reader.readAsDataURL(this.voucher_file)
    },

    async POST() {
      let {
        products,
        selec_plan,
        voucher,
        office,
        check,
        pay_method,
        bank,
        date,
        voucher_number,
        total,
      } = this

      let price = selec_plan.amount
      if (!pay_method) {
        this.error = 'Seleccione método de pago'
        return
      }
      if (pay_method == 'bank') {
        if (!bank) {
          this.error = 'Nombre de entidad'
          return
        }
        if (!date) {
          this.error = 'Fecha de voucher'
          return
        }
        if (!voucher_number) {
          this.error = 'Número de voucher'
          return
        }
        if (!voucher) {
          this.error = 'Voucher de pago'
          return
        }
      }

      if (!office) {
        this.error = 'Seleccione oficina'
        return
      }

      switch (this.max_mode) {
        case 'slots_categories': {
          const max_products_total = this.slots_categories.reduce(
            (a, c) => a + c.to_select,
            0
          )
          if (this.total < max_products_total) {
            this.error = 'Seleccione los productos de las categorías necesarias'
            return
          }
          break
        }
        case 'max_products': {
          if (this.total < this.selec_plan.max_products) {
            this.error = 'Seleccione más productos'
            return
          }
          break
        }
        case 'exact_weight_points': {
          if (this.total < this.selec_plan.exact_weight_points) {
            this.error = `Seleccione más productos hasta cubrir los ${this.text_value_max_mode} pesos de puntos`
            return
          }
          break
        }
        default:
          break
      }

      this.error = null

      // POST Affiliation
      this.sending = true

      if (voucher)
        voucher = await lib.upload(
          this.voucher_file,
          this.voucher_file.name,
          'affiliations'
        )

      const { data } = await api.Afiliation.POST(this.session, {
        products,
        price,
        selec_plan,
        voucher,
        office: office.id,
        check,
        remaining: this.remaining,
        pay_method,
        bank,
        date,
        voucher_number,
        total,
      })
      console.log({ data })

      this.sending = false
      this.pending = true

      this.affiliation = {
        plan: this.selec_plan,
        products: this.products,
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
c-gold = #D4AF37
c-ink = #1a1a1a
c-muted = #6b6b6b
c-line = #e6e6e6
c-bg = #f5f5f5

.aff-tabs
  margin-bottom 12px
  &__link
    font-weight 700
    color c-ink
    padding-bottom 4px
    border-bottom 2px solid c-gold

.aff
  display grid
  grid-template-columns minmax(0, 1fr)
  gap 16px
  min-width 0
  width 100%
  max-width 100%
  box-sizing border-box
  @media (min-width 1100px)
    grid-template-columns minmax(0, 1fr) 400px
    gap 20px

.aff-main
  min-width 0
  width 100%
  max-width 100%
  box-sizing border-box

.aff-congrats
  grid-column 1 / -1
  text-align center
  &__img
    width 100%
    max-width 600px

.aff-pending
  grid-column 1 / -1
  display flex
  justify-content center
  &__card
    background white
    border-radius 16px
    padding 28px 24px
    text-align center
    box-shadow 0 8px 24px rgba(0,0,0,.06)
    max-width 420px
    i
      font-size 36px
      color c-gold
      margin-bottom 10px
    h3
      margin 0 0 6px
    p
      color c-muted
      margin 0 0 14px
  &__plan
    display flex
    justify-content space-between
    font-weight 700
    margin-bottom 10px
  &__list
    text-align left
    font-size 13px
    color #555

.aff-header
  margin-bottom 14px
  &--desktop
    display none
    @media (min-width 1100px)
      display block

.aff-title
  margin 0
  font-size 24px
  font-weight 800
  padding-left 10px
  border-left 4px solid c-gold
  @media (min-width 1100px)
    font-size 28px

.aff-subtitle
  margin 8px 0 0
  color c-muted
  font-size 13px

.aff-plans
  display grid
  grid-template-columns repeat(2, minmax(0, 1fr))
  gap 10px
  margin-bottom 12px
  min-width 0
  width 100%
  max-width 100%
  box-sizing border-box
  @media (min-width 768px)
    grid-template-columns repeat(4, minmax(0, 1fr))

.aff-plan
  border 2px solid #eaeaea
  border-radius 12px
  background white
  padding 12px 10px
  text-align center
  cursor pointer
  transition .2s
  min-width 0
  width 100%
  box-sizing border-box
  &.is-active
    border-color c-gold
    box-shadow 0 4px 14px rgba(212,175,55,.25)
  &__img
    height 50px
    display flex
    align-items center
    justify-content center
    margin-bottom 6px
    img
      max-height 50px
      object-fit contain
  strong
    display block
    font-size 13px
    text-transform uppercase
  &__price
    color c-gold
    font-weight 800
    margin 4px 0
  small
    color c-muted
    font-size 11px

.aff-hint
  font-size 12px
  color #444
  margin 0 0 10px

.aff-toolbar
  display flex
  flex-direction column
  gap 10px
  margin-bottom 10px
  min-width 0
  width 100%
  max-width 100%
  box-sizing border-box
  @media (max-width 1099px)
    background white
    border-radius 12px
    border 1px solid #f0f0f0
    padding 12px
    box-shadow 0 2px 8px rgba(0,0,0,.05)

.aff-search
  display flex
  align-items center
  gap 8px
  background #f8f9fa
  border 2px solid #e0e0e0
  border-radius 999px
  padding 10px 14px
  min-width 0
  width 100%
  box-sizing border-box
  i
    color #666
  input
    border none
    outline none
    width 100%
    min-width 0
    background transparent
    font-size 14px

.aff-filters
  display flex
  gap 8px
  overflow-x auto
  min-width 0
  width 100%
  max-width 100%
  box-sizing border-box
  &::-webkit-scrollbar
    display none

.aff-chip
  border 2px solid #e0e0e0
  background white
  color #666
  border-radius 999px
  padding 7px 14px
  font-size 12px
  font-weight 700
  white-space nowrap
  cursor pointer
  flex-shrink 0
  &.is-active
    background c-gold
    border-color c-gold
    color #111

.aff-count
  font-size 12px
  color c-muted
  margin 0 0 12px
  @media (max-width 1099px)
    background #f3f3f3
    border-radius 8px
    padding 8px 12px

.aff-grid
  display grid
  grid-template-columns repeat(2, minmax(0, 1fr))
  gap 10px
  overflow hidden
  min-width 0
  width 100%
  max-width 100%
  box-sizing border-box
  @media (min-width 768px)
    grid-template-columns repeat(4, 1fr)
    gap 14px
    overflow visible

.aff-card
  position relative
  min-width 0
  width 100%
  max-width 100%
  box-sizing border-box
  background white
  border-radius 12px
  box-shadow 0 4px 12px rgba(0,0,0,.06)
  border 1px solid #eaeaea
  padding 8px
  display flex
  flex-direction column
  align-items stretch

  &::before
    content ''
    position absolute
    top -1px
    left -1px
    width 0
    height 0
    border-top 20px solid c-gold
    border-right 20px solid transparent
    border-top-left-radius 12px
    z-index 1

  &__badge
    display inline-flex
    align-items center
    gap 4px
    position absolute
    top 0
    right 0
    z-index 2
    background c-gold
    color #111
    font-size 10px
    font-weight 700
    padding 4px 6px
    border-radius 0 12px 0 8px
    i
      font-size 9px
  &__img
    height 80px
    display flex
    align-items center
    justify-content center
    margin 12px 0 8px
    img
      max-width 100%
      max-height 80px
      object-fit contain
  &__info
    display flex
    flex-direction column
    flex 1
    text-align center
  &__name
    margin 0 0 4px
    font-size 12px
    font-weight 800
    text-transform uppercase
    color c-gold
    line-height 1.2
    display -webkit-box
    -webkit-line-clamp 2
    -webkit-box-orient vertical
    overflow hidden
  &__type
    font-size 11px
    color c-muted
    margin 0 0 6px
    display block
  &__price-label
    font-size 11px
    color c-ink
    font-weight 700
    margin-bottom 2px
    display block
  &__price
    margin 0 0 10px
    font-size 15px
    font-weight 800
    color c-ink
  &__btn
    margin-top auto
    width 100%
    background c-gold
    color #111
    border none
    border-radius 8px
    padding 8px
    font-weight 700
    font-size 12px
    cursor pointer
    display flex
    align-items center
    justify-content center
    gap 6px
    i
      font-size 12px
  &__controls
    margin-top auto
    display flex
    align-items center
    justify-content space-between
    background #f5f5f5
    border-radius 8px
    padding 3px
    .btn-ctrl
      width 28px
      height 28px
      border none
      background white
      color c-ink
      border-radius 6px
      font-size 14px
      display flex
      align-items center
      justify-content center
      cursor pointer
      box-shadow 0 1px 4px rgba(0,0,0,.05)
    .ctrl-qty
      font-weight 700
      font-size 13px
      color c-ink
      min-width 24px
      text-align center

  @media (min-width 768px)
    position relative
    overflow hidden
    padding 14px 12px 52px
    min-height 280px
    border-radius 14px
    box-shadow 0 8px 24px rgba(0,0,0,.06)
    align-items stretch
    &::before
      content ''
      position absolute
      top -1px
      left -1px
      width 0
      height 0
      border-top 24px solid #D4AF37
      border-right 24px solid transparent
      border-top-left-radius 14px
      z-index 1
    &__badge
      display inline-flex
      align-items center
      gap 4px
      position absolute
      top 10px
      right 10px
      background #D4AF37
      color #fff
      font-size 11px
      font-weight 700
      padding 4px 10px
      border-radius 6px
      box-shadow 0 3px 8px rgba(0,0,0,0.15)
      border 1.5px solid #fff
      z-index 3
      i
        font-size 10px
        color #fff
    &__img
      height 140px
      img
        max-height 140px
    &__info
      text-align center
      align-items center
      width 100%
    &__name
      font-size 14px
      min-height 36px
      color #B38728
      text-align center
      width 100%
    &__type
      display block
      text-align center
      color #666
      font-size 12px
      margin 0 0 6px
    &__price-label
      display block
      text-align center
      color #666
      font-weight 500
    &__price
      display block
      font-size 20px
      margin 2px 0 10px
      color #111
      text-align center
      font-weight 800
    &__btn
      width 100%
      height 44px
      margin 0
      padding 0
      font-size 13px
      border-radius 0 0 14px 14px
      background #D4AF37
      color #fff
      i
        color #fff
    &__controls
      position absolute
      left 0
      right 0
      bottom 0
      width 100%
      height 44px
      margin 0
      border-radius 0 0 14px 14px
      padding 0 10px
      background #D4AF37
      box-sizing border-box
      .btn-ctrl
        width 32px
        height 32px
        font-size 16px
        border-radius 8px
        background transparent
        color #fff
        box-shadow none
      .ctrl-qty
        font-size 15px
        min-width 24px
        text-align center
        color #fff

@media (min-width 768px)
  .product-catalog-info
    text-align center
    align-items center
  .product-catalog-name
    color #B38728
    text-align center
  .product-catalog-info-text
    display block
    text-align center
    color #666
  .product-catalog-price
    text-align center
    font-size 12px
    color #666
    font-weight 500
    width 100%
    .price-amount
      display block
      color #111
      font-size 20px
      font-weight 800
      margin-top 2px
  .add-to-cart-container
    position absolute
    left 0
    right 0
    bottom 0
    width 100%
    height 44px
    margin 0
  .add-to-cart-btn
    width 100%
    height 44px
    margin 0
    border-radius 0 0 14px 14px
    background #D4AF37
    color #fff
    box-shadow none
    i
      color #fff

.aff-mobile-cart
  display none
  @media (max-width 1099px)
    display flex
    align-items center
    justify-content space-between
    gap 10px
    background white
    border 1px solid rgba(212,175,55,.2)
    border-radius 14px
    padding 12px 14px
    margin 0
    position relative
    z-index 30
    box-shadow 0 4px 12px rgba(212,175,55,.12)
    box-sizing border-box
  &.is-hidden
    visibility hidden
    pointer-events none
  &__info
    display flex
    flex-direction column
    font-size 13px
    font-weight 700
  &__btn
    border none
    border-radius 10px
    padding 12px 14px
    background linear-gradient(135deg, #D4AF37, #c9a227)
    color #111
    font-weight 800
    font-size 12px
    cursor pointer
    display inline-flex
    align-items center
    gap 6px

.aff-cart
  display none
  @media (min-width 1100px)
    display block
    background white
    border-radius 14px
    padding 16px
    box-shadow 0 8px 24px rgba(0,0,0,.06)
    position sticky
    top 12px
    align-self start
    height fit-content
    max-height calc(100vh - 24px)
    overflow-y auto
  &--checkout
    display none
    @media (min-width 1100px)
      display block
      background white
      border-radius 14px
      padding 16px
      box-shadow 0 8px 24px rgba(0,0,0,.06)
      position sticky
      top 12px
      align-self start
      height fit-content
      max-height calc(100vh - 24px)
      overflow-y auto
  &--modal
    display flex !important
    flex-direction column
    position fixed
    top 0
    right 0
    width 100%
    max-width 420px
    height 100vh
    height 100dvh
    background white
    border-radius 0
    z-index 10000
    padding 16px
    transform translateX(100%)
    transition transform .3s ease
    .is-open &
      transform translateX(0)
  &__head
    h3
      margin 0
      color c-gold
      font-size 16px
      display flex
      align-items center
      gap 8px
    p
      margin 4px 0 0
      color c-muted
      font-size 12px
  &__close
    position absolute
    top 12px
    right 12px
    border none
    background transparent
    font-size 20px
    cursor pointer
  &__body
    margin-top 12px
  max-height 240px
    overflow auto
  &__empty
    text-align center
    color #aaa
    padding 24px 0
    i
      font-size 28px
      margin-bottom 8px
  &__summary
    margin-top 12px
    border-top 1px solid c-line
    padding-top 12px
    .row
      display flex
      justify-content space-between
      font-size 13px
      margin-bottom 6px
      color #555
      &--total
        font-weight 800
        color c-ink
        font-size 16px
        span:last-child
          color c-gold
  &__actions
    display flex
    flex-direction column
    gap 8px
    margin-top 12px

.aff-cart-item
  display flex
  align-items center
  gap 8px
  padding 8px 0
  border-bottom 1px solid #f0f0f0
  img
    width 40px
    height 40px
    object-fit contain
    background c-bg
    border-radius 6px
  &__info
    flex 1
    min-width 0
    strong
      display block
      font-size 11px
      text-transform uppercase
    small
      color c-muted
  &__qty
    display inline-flex
    align-items center
    gap 6px
    background c-bg
    border-radius 8px
    padding 3px 6px
    button
      border none
      background transparent
      cursor pointer
      font-weight 700
      width 18px

.aff-overlay
  position fixed
  inset 0
  background rgba(0,0,0,.45)
  z-index 9999
  opacity 0
  pointer-events none
  transition opacity .3s
  &.is-open
    opacity 1
    pointer-events auto

.btn
  width 100%
  border none
  border-radius 10px
  padding 12px
  font-weight 800
  cursor pointer
  display flex
  align-items center
  justify-content center
  gap 8px
  &--primary
    background c-gold
    color #111
  &--ghost
    background #111
    color c-gold

.checkout-mobile-actions
  display none
  @media (max-width 1099px)
    display flex
    flex-direction column
    gap 10px
    background white
    border-radius 14px
    padding 16px
    margin 0 0 88px
    box-shadow 0 6px 18px rgba(0,0,0,.06)
  &__summary
    margin-bottom 4px
    .row
      display flex
      justify-content space-between
      font-size 14px
      color #555
      margin-bottom 6px
      &:last-child
        font-weight 800
        color #111
        font-size 16px
        span:last-child
          color c-gold

.aff-checkout-block
  background white
  border-radius 14px
  padding 16px
  margin-bottom 12px
  box-shadow 0 4px 14px rgba(0,0,0,.04)
  &__title
    margin 0 0 12px
    display flex
    align-items center
    gap 8px
    font-size 15px
    span
      width 22px
      height 22px
      border-radius 50%
      background c-gold
      color #111
      font-size 11px
      display inline-flex
      align-items center
      justify-content center

.aff-field
  display flex
  flex-direction column
  gap 5px
  font-size 12px
  margin-bottom 8px
  span
    font-weight 700
  input, select
    border 1px solid c-line
    border-radius 10px
    padding 10px 12px
    font-size 14px

.aff-field-hint
  font-size 12px
  color c-muted

.aff-payinfo
  display grid
  gap 12px
  margin-bottom 12px
  @media (min-width 800px)
    grid-template-columns 1fr 1fr

.aff-pay-card
  background white
  border-radius 14px
  padding 14px
  box-shadow 0 4px 14px rgba(0,0,0,.04)
  h4
    margin 0 0 10px
  pre
    white-space pre-wrap
    font-family inherit
    font-size 12px
    background c-bg
    padding 10px
    border-radius 8px
  img
    width 100%
    max-width 200px
    display block
    margin 0 auto
    border-radius 8px

.aff-toggle
  display flex
  justify-content space-between
  align-items center
  font-weight 700
  gap 12px

.aff-balance
  margin-top 10px
  background c-bg
  border-radius 10px
  padding 10px
  font-size 13px
  p
    margin 0 0 4px

.aff-pay-methods
  display grid
  gap 10px
  @media (min-width 700px)
    grid-template-columns 1fr 1fr

.aff-pay-method
  display flex
  gap 10px
  text-align left
  border 1px solid c-line
  background white
  border-radius 12px
  padding 12px
  cursor pointer
  i
    color c-gold
    margin-top 2px
  strong
    display block
    margin-bottom 2px
  small
    color c-muted
    font-size 11px
  &.is-selected
    border-color c-gold
    box-shadow 0 0 0 2px rgba(212,175,55,.25)

.aff-transfer
  margin-top 12px
  &__monto
    font-weight 700
    margin-bottom 10px
  &__grid
    display grid
    gap 10px
    @media (min-width 700px)
      grid-template-columns 1fr 1fr

.aff-upload
  margin-top 12px
  border 1.5px dashed #ccc
  border-radius 12px
  padding 20px
  text-align center
  display block
  position relative
  cursor pointer
  color c-muted
  input
    position absolute
    inset 0
    opacity 0
    cursor pointer
  i
    color c-gold
    font-size 22px
    display block
    margin-bottom 6px
  img
    max-width 160px
    max-height 120px
    border-radius 8px
  &.has-file
    border-color c-gold

.aff-cash
  margin-top 12px
  background c-bg
  border-radius 10px
  padding 12px
  font-size 14px

.aff-error
  color #c0392b
  font-weight 700
  margin-top 8px

.aff-invoices
  grid-column 1 / -1
  margin-top 8px
  a
    color #888
    margin-right 12px
    font-size 13px
</style>
<style lang="stylus">
.cart-button-mobile-anchor,
.aff-mobile-cart-anchor {
  width: 100%;
  margin: 12px 0 16px;
  position: relative;
}

@media (min-width: 1100px) {
  .cart-button-mobile-anchor,
  .aff-mobile-cart-anchor,
  .cart-button-container-mobile,
  .aff-mobile-cart {
    display: none !important;
  }
}

.cart-button-mobile-sentinel,
.aff-mobile-cart-sentinel {
  width: 100%;
  height: 1px;
  margin: 0;
  padding: 0;
  pointer-events: none;
}

.cart-button-container-mobile,
.aff-mobile-cart {
  display: flex !important;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 16px;
  padding: 14px 18px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);
  border: 1px solid #eaeaea;
  position: relative;
  z-index: 40;
  box-sizing: border-box;
  width: 100%;
}

.cart-button-container-mobile.is-stuck,
.aff-mobile-cart.is-stuck {
  position: fixed !important;
  top: 8px !important;
  z-index: 2000 !important;
  margin: 0 !important;
  box-shadow: 0 6px 18px rgba(212, 175, 55, 0.28) !important;
}

.cart-button-container-mobile.is-hidden,
.aff-mobile-cart.is-hidden {
  visibility: hidden;
  pointer-events: none;
}

.cart-info-left,
.aff-mobile-cart__info {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.cart-price-info {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.total-price,
.total-items {
  font-size: 0.95rem;
  font-weight: 700;
  color: #111;
  line-height: 1.25;
}

.cart-square-btn,
.aff-mobile-cart__btn {
  flex-shrink: 0;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  border-radius: 10px;
  padding: 12px 18px;
  background: #D4AF37 !important;
  color: #fff !important;
  font-size: 0.9rem;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 4px 14px rgba(212, 175, 55, 0.35);
  transition: all 0.25s ease;
}

.cart-square-btn:hover,
.aff-mobile-cart__btn:hover {
  background: #c9a227 !important;
  box-shadow: 0 6px 18px rgba(201, 162, 39, 0.45);
}

.cart-square-btn i,
.aff-mobile-cart__btn i {
  font-size: 1.05rem;
  color: #fff !important;
}

/* Indicador contador como en Sifrah */
.products-count-indicator,
.aff-count {
  grid-column: 1 / -1;
  text-align: center;
  padding: 10px 14px;
  background: #f8f9fa;
  border-radius: 8px;
  margin: 0 0 14px;
  font-size: 0.85rem;
  color: #666;
  border: 1px solid #e9ecef;
  width: 100%;
  box-sizing: border-box;
}

.products-count-indicator .filter-active,
.aff-count .filter-active {
  color: #D4AF37;
  font-weight: 600;
  margin-left: 8px;
}

/* Esquina dorada y badge de puntos en Web y Móvil */
.card-corner {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 0 !important;
  height: 0 !important;
  border-style: solid !important;
  border-width: 24px 24px 0 0 !important;
  border-color: #D4AF37 transparent transparent transparent !important;
  z-index: 2 !important;
  opacity: 0.95 !important;
}

/* Badge de puntos en Web y Móvil */
.points-badge,
.aff-card__badge {
  display: inline-flex !important;
  align-items: center !important;
  gap: 4px !important;
  position: absolute !important;
  top: 10px !important;
  right: 10px !important;
  background: #D4AF37 !important;
  color: #fff !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  padding: 4px 10px !important;
  border-radius: 6px !important;
  box-shadow: 0 3px 8px rgba(0,0,0,0.15) !important;
  border: 1.5px solid #fff !important;
  z-index: 3 !important;
}

.points-badge i,
.aff-card__badge i {
  font-size: 10px !important;
  color: #fff !important;
}

/* Grilla y tarjetas Sifrah */
@media (max-width: 1099px) {
  .aff {
    min-width: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    overflow: hidden !important;
  }

  .aff-main {
    min-width: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
  }

  .aff-toolbar,
  .aff-filters,
  .aff-plans {
    min-width: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
  }

  .products-catalog-grid,
  .aff-grid {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 10px !important;
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    padding: 0 !important;
    box-sizing: border-box !important;
  }

  .product-catalog-card,
  .aff-card {
    background: linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%) !important;
    border-radius: 12px !important;
    box-shadow: 0 4px 15px rgba(0,0,0,0.08), 0 2px 6px rgba(0,0,0,0.05) !important;
    padding: 10px 6px !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    position: relative !important;
    transition: all 0.3s ease !important;
    border: 1px solid #f0f0f0 !important;
    min-height: 240px !important;
    overflow: hidden !important;
    box-sizing: border-box !important;
    min-width: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
  }

  /* Doble marco interior como Sifrah */
  .product-catalog-card::before,
  .aff-card::before {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    right: 2px;
    bottom: 2px;
    border: 1px solid #f0f0f0;
    border-radius: 10px;
    pointer-events: none;
    z-index: 1;
  }

  .product-catalog-card::after,
  .aff-card::after {
    content: '';
    position: absolute;
    top: 5px;
    left: 5px;
    right: 5px;
    bottom: 5px;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    pointer-events: none;
    z-index: 1;
  }

  /* Esquina doblada triangular */
  .product-catalog-card .card-corner,
  .aff-card .card-corner {
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 22px 22px 0 0;
    border-color: #D4AF37 transparent transparent transparent;
    z-index: 2;
    opacity: 0.95;
  }

  /* Badge de puntos estrella */
  .points-badge,
  .aff-card__badge {
    position: absolute;
    top: 6px;
    right: 6px;
    background: #D4AF37 !important;
    color: #fff !important;
    border-radius: 4px !important;
    padding: 3px 6px !important;
    font-size: 0.7rem !important;
    font-weight: 700 !important;
    display: flex !important;
    align-items: center !important;
    gap: 3px !important;
    box-shadow: 0 2px 6px rgba(0,0,0,0.15) !important;
    z-index: 3 !important;
    border: 1px solid #fff !important;
  }

  .points-badge i,
  .aff-card__badge i {
    font-size: 0.6rem !important;
    color: #fff !important;
  }

  /* Contenedor imagen producto centrado */
  .product-image-container,
  .aff-card__img {
    width: 84px !important;
    height: 84px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin: 8px auto 10px auto !important;
    border-radius: 10px !important;
    border: 1px solid #e8e8e8 !important;
    box-shadow: 0 2px 8px rgba(0,0,0,0.06) !important;
    background: #fff !important;
    overflow: hidden !important;
    position: relative !important;
    z-index: 2 !important;
    flex-shrink: 0 !important;
  }

  .product-catalog-img,
  .aff-card__img img {
    max-width: 100% !important;
    max-height: 100% !important;
    object-fit: contain !important;
  }

  /* Textos centrados */
  .product-catalog-info,
  .aff-card__info {
    width: 100% !important;
    text-align: center !important;
    margin-bottom: 6px !important;
    position: relative !important;
    z-index: 2 !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    flex: 1 !important;
  }

  .product-catalog-name,
  .aff-card__name {
    font-size: 0.85rem !important;
    font-weight: 700 !important;
    color: #B38728 !important;
    margin-bottom: 3px !important;
    line-height: 1.2 !important;
    text-align: center !important;
    min-height: 2.2em !important;
    display: -webkit-box !important;
    -webkit-line-clamp: 2 !important;
    -webkit-box-orient: vertical !important;
    overflow: hidden !important;
    text-transform: uppercase !important;
    width: 100% !important;
  }

  .product-catalog-info-text,
  .aff-card__type {
    font-size: 0.75rem !important;
    color: #666 !important;
    font-weight: 500 !important;
    margin-bottom: 4px !important;
    line-height: 1.2 !important;
    text-align: center !important;
    min-height: 1.2em !important;
  }

  .product-catalog-price {
    font-size: 0.75rem !important;
    color: #333 !important;
    font-weight: 500 !important;
    margin-bottom: 6px !important;
    text-align: center !important;
  }

  .price-amount,
  .aff-card__price {
    display: block !important;
    font-size: 1.15rem !important;
    font-weight: 800 !important;
    color: #111 !important;
    margin-top: 1px !important;
    margin-bottom: 6px !important;
    text-align: center !important;
  }

  .add-to-cart-container {
    margin-top: auto !important;
    width: 100% !important;
    position: relative !important;
    z-index: 2 !important;
  }

  .add-to-cart-btn,
  .aff-card__btn {
    background: #D4AF37 !important;
    color: #fff !important;
    border: none !important;
    border-radius: 8px !important;
    padding: 9px 12px !important;
    font-weight: 700 !important;
    font-size: 0.85rem !important;
    cursor: pointer !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 6px !important;
    box-shadow: 0 3px 10px rgba(212, 175, 55, 0.3) !important;
    width: 100% !important;
  }

  .add-to-cart-btn i,
  .aff-card__btn i {
    font-size: 0.85rem !important;
    color: #fff !important;
  }

  .product-quantity-controls,
  .aff-card__controls {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    margin-top: auto !important;
    width: 100% !important;
    background: #D4AF37 !important;
    border-radius: 20px !important;
    padding: 2px !important;
    box-shadow: 0 2px 8px rgba(212, 175, 55, 0.25) !important;
    position: relative !important;
    z-index: 2 !important;
  }

  .qty-control-btn,
  .aff-card__controls .btn-ctrl {
    background: transparent !important;
    color: #fff !important;
    border: none !important;
    width: 28px !important;
    height: 28px !important;
    font-size: 1rem !important;
    font-weight: 700 !important;
    cursor: pointer !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    box-shadow: none !important;
  }

  .quantity-display,
  .aff-card__controls .ctrl-qty {
    font-size: 0.9rem !important;
    font-weight: 700 !important;
    color: #fff !important;
    min-width: 20px !important;
    text-align: center !important;
  }
}

@media (max-width: 480px) {
  .products-catalog-grid,
  .aff-grid {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 10px !important;
  }

  .product-catalog-card,
  .aff-card {
    padding: 10px 6px !important;
    min-height: 235px !important;
  }

  .product-image-container,
  .aff-card__img {
    width: 72px !important;
    height: 72px !important;
  }

  .product-catalog-name,
  .aff-card__name {
    font-size: 0.8rem !important;
  }
}

/* Desktop: Agregar y cantidad, mismo alto y de extremo a extremo */
@media (min-width: 768px) {
  .product-catalog-card.aff-card,
  .aff-card {
    padding: 14px 12px 52px !important;
    overflow: hidden !important;
  }

  .add-to-cart-container {
    position: absolute !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    width: 100% !important;
    height: 44px !important;
    margin: 0 !important;
    z-index: 2 !important;
  }

  .add-to-cart-btn,
  .aff-card__btn {
    width: 100% !important;
    height: 44px !important;
    margin: 0 !important;
    padding: 0 !important;
    border-radius: 0 0 14px 14px !important;
    background: #D4AF37 !important;
    color: #fff !important;
    box-shadow: none !important;
  }

  .add-to-cart-btn i,
  .aff-card__btn i {
    color: #fff !important;
  }

  .product-quantity-controls,
  .aff-card__controls {
    position: absolute !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    width: 100% !important;
    height: 44px !important;
    margin: 0 !important;
    padding: 0 10px !important;
    border-radius: 0 0 14px 14px !important;
    background: #D4AF37 !important;
    box-shadow: none !important;
    box-sizing: border-box !important;
    z-index: 2 !important;
  }

  .aff-card__controls .btn-ctrl,
  .qty-control-btn {
    width: 32px !important;
    height: 32px !important;
    background: transparent !important;
    color: #fff !important;
    box-shadow: none !important;
  }

  .aff-card__controls .ctrl-qty,
  .quantity-display {
    color: #fff !important;
    font-size: 15px !important;
  }
}

/* Permite sticky del carrito desktop (el layout app usa overflow:hidden) */
@media (min-width: 1100px) {
  body.vf-sticky-cart .app > section {
    overflow: visible !important;
  }
  body.vf-sticky-cart .app > section .content {
    overflow: visible !important;
  }
  body.vf-sticky-cart .app > section .content > section {
    overflow: visible !important;
  }
}
</style>
